import React, { ReactElement } from "react";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import { Container, SvgIconProps } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import iconsOverviewPageStyle from "./iconsOverviewPageStyle";
import { Navigate } from "react-router";

export default function IconsOverviewPage() {
  const iconModules = import.meta.glob("../../../../assets/icons/**/*.tsx", {
    eager: true,
  });

  if (import.meta.env.VITE_DEPLOYMENT === "production") {
    return <Navigate to={"/"} />;
  }

  const getIconName = (path: string) => {
    return path.replace("../../../../assets/icons/", "").replace(".tsx", "") || "";
  };

  const copyToClipboard = (iconName: string) => {
    navigator.clipboard.writeText(iconName);
  };

  const generateAllSvgIconComponentList = () => {
    const icons: ReactElement<SvgIconProps>[] = [];

    Object.entries(iconModules).forEach(([path, module]: [string, any]) => {
      const IconComponent = module.default;
      const isToggleable = path.includes("toggleable");

      const iconStates = isToggleable
        ? [
          { active: true, label: "Active" },
          { active: false, label: "InActive" },
        ]
        : [{ active: false, label: "" }];

      iconStates.forEach(({ active, label }) => {
        const iconName = getIconName(path);
        icons.push(
          <Grid
            key={path + (label ? `-${label}` : "")}
            sx={iconsOverviewPageStyle.grid}
            size={{
              xs: 2,
              sm: 2
            }}>
            <IconComponent sx={iconsOverviewPageStyle.icon} active={active} />
            <Typography
              sx={iconsOverviewPageStyle.typography}
              onClick={() => copyToClipboard(iconName)}
            >
              {iconName} {label && `- (${label})`}
            </Typography>
          </Grid>
        );
      });
    });

    return icons;
  };

  return (
    <LayoutPublicRoutes>
      <Container>
        <Grid container spacing={2} sx={iconsOverviewPageStyle.container}>
          {generateAllSvgIconComponentList()}
        </Grid>
      </Container>
    </LayoutPublicRoutes>
  );
}
